/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Loud_Jannes_AmazeInputs */

const fr_fair_loud_jannes_amaze = /** @type {(inputs: Fair_Loud_Jannes_AmazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer Cours / Prog`)
};

/**

* @param {Fair_Loud_Jannes_AmazeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fair_loud_jannes_amaze = /** @type {((inputs?: Fair_Loud_Jannes_AmazeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Loud_Jannes_AmazeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fair_loud_jannes_amaze(inputs)
});